// Constantes de movimento — valores de servidor de surf clássico do Source.
// FONTE ÚNICA. Espec completa e fórmulas: docs/02-MOVEMENT.md.
// Unidades: units do Source (1u = 0.0254m), velocidade em units/s, ângulos em graus.

export const GRAVITY = 800; // sv_gravity
export const AIR_ACCELERATE = 150; // sv_airaccelerate (surf padrão)
export const ACCELERATE = 5; // sv_accelerate (chão)
export const FRICTION = 4; // sv_friction
export const STOP_SPEED = 75; // sv_stopspeed
export const MAX_VELOCITY = 3500; // sv_maxvelocity (clamp POR EIXO)
export const RUN_SPEED = 260; // wishspeed máximo no chão
export const AIR_CAP = 30; // clamp do wishspeed no ar — o segredo do air strafe
export const JUMP_IMPULSE = 301.993; // velocidade vertical do pulo (sem stamina)
export const STAND_ON_NORMAL = 0.7; // normal.y >= 0.7 (~45.57°) = chão; abaixo = surfável
export const OVERBOUNCE = 1.0;
export const STEP_HEIGHT = 18; // degrau máximo no chão
export const DUCK_SPEED_MULT = 0.34; // wishspeed agachado no chão

// Hull do jogador (AABB), em units
export const HULL_HALF_XZ = 16; // 32x32 de base
export const HULL_HEIGHT = 72;
export const HULL_HEIGHT_DUCK = 54;
export const EYE_HEIGHT = 64;
export const EYE_HEIGHT_DUCK = 46;

// Mouse — mesma escala do CS
export const M_YAW = 0.022; // graus por count * sensibilidade
export const M_PITCH = 0.022;
export const PITCH_CLAMP = 89;

// Categorização de chão
export const GROUND_TRACE_DIST = 2; // trace pra baixo ao categorizar
export const MAX_GROUND_LAND_SPEED = 180; // vel.y acima disso não "gruda" no chão

// Zonas
export const START_ZONE_SPEED_CAP = 350; // len(vel.xz) máx ao sair da zona start (anti-prespeed)
